import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { AlertService } from '../../service/alert.service';
import { environment } from '../../environments/environment';
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatSelect, MatOption } from "@angular/material/select";
import { PasswordValidationComponent } from "../../shared/password-validation/password-validation.component";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
  selector: 'app-registration',
  standalone: true,
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.css',
  imports: [MatIcon, MatFormField, MatLabel, MatSelect, MatOption, PasswordValidationComponent, AlertMessageComponent, FormsModule, CommonModule, RouterModule, TranslateModule, MatCheckboxModule]
})
export class RegistrationComponent implements OnInit {
  
  constructor(private http: HttpClient, private router: Router, 
    private alertService:AlertService, private translate: TranslateService) {}

  email: string = '';
  password: string = '';
  confirmPassword: string = '';
  sector: string = '';
  isPasswordValid: boolean = false;
  sectors: any[] = [];
  loadingSectors: boolean = false;
  loadingRegister: boolean = false;
  showPassword: boolean = false;

  // RICHIAMA LA FUNZIONE CARICA I SETTORI ALL'INIZIO 
  ngOnInit() {
    this.loadSectors();
  }

  // CARICA I SETTORI FACENDO UNA CHIAMATA API
  loadSectors() {
    this.loadingSectors = true;
    this.http.get<any[]>(environment.apiUrl + '/api/companies/sectors')
      .subscribe({
        next: (data) => {
          this.sectors = data;
          this.loadingSectors = false;
        },
        error: (err) => {
          this.alertService.errorKey('auth.registration.errors.load-sectors');
          this.loadingSectors = false;
        }
      });
  }

  //
  onPasswordValidityChange(isValid: boolean) {
    this.isPasswordValid = isValid;
  }

  register(form: NgForm) {

     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.value.email)) {
      this.alertService.errorKey('auth.errors.invalid-email');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
        
    if (!this.isPasswordValid) {
      this.alertService.errorKey('auth.errors.password-requirements');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.alertService.errorKey('auth.registration.errors.password-mismatch');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (!form.valid) {
      this.alertService.errorKey('auth.errors.required-fields');
      return;
    }
    const formData = {
      email: this.email,
      password: this.password,
      sector: this.sector
    };

    this.loadingRegister=true;

    this.http.post(environment.apiUrl + '/api/auth/register', formData, { responseType: 'text' })
      .subscribe({
        next: (response: string) => {
          console.log("ok?")
          this.alertService.successKey('auth.registration.success', true)
          this.router.navigate(['/login']);
        },
        error: (err) => {
          const backendMessage =
            typeof err?.error === 'string'
              ? err.error
              : typeof err?.error?.message === 'string'
                ? err.error.message
                : '';

          this.alertService.errorKey(
            this.translateRegistrationErrorKey(backendMessage) || 'auth.errors.generic'
          );
          this.loadingRegister=false;
        }
      });
  }

  private translateRegistrationErrorKey(message: string): string {
    const normalizedMessage = message?.trim().toLowerCase();

    if (!normalizedMessage) {
      return '';
    }

    if (normalizedMessage.includes('email already in use')) {
      return 'auth.registration.errors.email-in-use';
    }

    if (normalizedMessage.includes('password must')) {
      return 'auth.errors.password-requirements';
    }

    return '';
  }

}

